//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('timeProjects', {
//        templateUrl: 'views/components/views/timeProjects/timeProjects.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['timeProjectsService', function (timeProjectsService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;

//            vm.model = {
//                itemsListTimeProjects: []
//            };

//		    // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadTimeProjects() {
//                vm.model.itemsListTimeProjects = await timeProjectsService.listTimeProjects({
//                    cust_name: 'ALL',
//                    project_keyno: '0',
//                    ok: '0'
//                });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                loadTimeProjects();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
